const isOverflowing = (element: HTMLElement) =>
  element.offsetWidth < element.scrollWidth;

export default isOverflowing;
